<template>
  <div class='sidebar-logo-container'
    :background-color='variables.menuBg'>
    <div class='logo-div'>
      <span class='img-span'>
        <!-- <img src='/images/logo/logo.png' class='img-logo'/> -->
        <img src='/images/logo/logo.png' class='img-logo-f'/>
      </span>
      <!-- <router-link to='/' class='router-link'> -->
        <!-- <span class='title-span'>管理系统</span> -->
      <!-- </router-link> -->
    </div>
  </div>
</template>

<script>
import variables from '@/styles/frame.scss'

export default {
  name: 'SidebarLogo',
  computed: {
    variables: function () {
      return variables
    }
  }
}
</script>

<style scoped>
.sidebar-logo-container {
  position: relative;
  width: calc(100% - 40px);
  height: 44px;
  line-height: 44px;
  overflow: hidden;
  padding: 0 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.logo-div {
  height: 44px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 44px;
  text-align: center;
}
.logo-div a {
  text-decoration: none;
}
.router-link {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.img-span {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.img-logo {
  height: 30px;
  width: 30px;
  background-color: #337ab7;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
}
.img-logo-f {
  height: 30px;
  width: 140px;
  margin-left: 20px;
  border-radius: 2px;
  background-color: #337ab7;
}
.title-span {
  height: 44px;
  line-height: 44px;
  width: 140px;
  font-size: 16px;
  text-align: start;
  color: #fff;
  text-decoration: none;
}
</style>
